(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["snippet-gift-wrapping"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gift-wrapping')) {
    customElements.define(
      'gift-wrapping',
      class GiftWrapping extends HTMLElement {
        constructor() {
          super();
          this.handleCartUpdatedBound = this.handleCartUpdated.bind(this);
          this.productId = Number(this.dataset.productId);
          this.hideProductId = Number(this.dataset.hideProductId) || null;
        }

        #zoomAbortController = null;

        connectedCallback() {
          window.addEventListener('cart-updated', this.handleCartUpdatedBound);
          this.#bindZoom();

          const cartStateJson = this.closest('cart-form')?.querySelector('[data-cart-state-json]')?.textContent;

          if (cartStateJson) {
            try {
              this.#syncVisibility(JSON.parse(cartStateJson));
            } catch {
              // Ignore malformed cart state JSON
            }
          }
        }

        disconnectedCallback() {
          window.removeEventListener('cart-updated', this.handleCartUpdatedBound);
          this.#zoomAbortController?.abort();
        }

        #syncVisibility(cart) {
          if (!Array.isArray(cart?.items) || !this.productId) return;

          const shouldHide =
            cart.items.some((item) => Number(item.product_id) === this.productId) ||
            (this.hideProductId && cart.items.some((item) => Number(item.product_id) === this.hideProductId)) ||
            cart.item_count === 0;
          const hiddenValue = shouldHide ? 'true' : 'false';

          const container = this.closest('.gift-wrapping-container');

          if (container) {
            container.setAttribute('data-hidden', hiddenValue);
          }

          this.setAttribute('data-hidden', hiddenValue);

          const giftWrap = this.closest('.block-gift-card-container')?.querySelector('.block-gift-card');

          if (giftWrap) {
            giftWrap.setAttribute('data-gift-wrapping-hidden', hiddenValue);
          }
        }

        handleCartUpdated(event) {
          this.#syncVisibility(event.detail);
        }

        #bindZoom() {
          const imageTrigger = this.querySelector('.icon-zoom');
          const imageContainer = this.querySelector('.gift-wrapping-image');

          if (!imageTrigger || !imageContainer) return;

          this.#zoomAbortController?.abort();
          this.#zoomAbortController = new AbortController();
          const { signal } = this.#zoomAbortController;

          imageTrigger.addEventListener(
            'click',
            (event) => {
              event.stopPropagation();
              this.toggleAttribute('data-zoomed');
            },
            { signal }
          );

          imageContainer.addEventListener(
            'click',
            () => {
              this.removeAttribute('data-zoomed');
            },
            { signal }
          );
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["snippet-marketing-tray"] && !Shopify.designMode) return;
  try {
    (function handleMarketingTray() {
    const storage = localStorage.getItem('marketing-tray');
    const tray = window.traps.store['marketing-tray'];

    if (tray && storage !== 'true') {
      setTimeout(() => {
        if (window.traps.store['cookies'].active) return;

        tray.activate();
        localStorage.setItem('marketing-tray', 'true');
      }, 10000);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["snippet-product-shop-the-look-modal"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('shop-the-look-modal')) {
    customElements.define(
      'shop-the-look-modal',
      class ShopTheLookModal extends HTMLElement {
        constructor() {
          super();

          this.handlePanelClick = this.handlePanelClick.bind(this);

          /** @type {HTMLButtonElement | null} */
          this.trigger = this.querySelector('[data-focus-trap-toggle]');

          /** @type {HTMLElement | null} */
          this.panel = this.closest('.section-panel-content');
        }

        connectedCallback() {
          if (!this.trigger || !this.panel) return;

          this.panel.addEventListener('click', this.handlePanelClick);
        }

        disconnectedCallback() {
          if (!this.panel) return;

          this.panel.removeEventListener('click', this.handlePanelClick);
        }

        /** @param {MouseEvent} event */
        handlePanelClick(event) {
          if (!this.trigger) return;

          const target = event.target;

          if (target instanceof HTMLElement) {
            if (
              target.closest('[data-product-hotspot-button]') ||
              target.closest('.product-hotspot') ||
              target.closest('product-hotspot') ||
              target.closest('[data-focus-trap-toggle]')
            ) {
              return;
            }
          }

          this.trigger.click();
        }
      },
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["snippet-products-lister-header"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('quick-link')) {
    customElements.define(
      'quick-link',
      class extends HTMLElement {
        constructor() {
          super();

          this.link = this.querySelector('a[data-collection-quick-link]');
        }

        connectedCallback() {
          if (!this.link) return;

          const currentPath = `${window.location.pathname}${window.location.search}`;
          const linkUrl = new URL(this.link.href, window.location.origin);
          const linkPath = `${linkUrl.pathname}${linkUrl.search}`;

          if (currentPath === linkPath) {
            this.link.classList.remove('button--outline');
            this.link.classList.add('button', 'products-lister-header-groups-list-item--current');
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
